

export class SlotAvailability {

    public lastPublishedDate: Date = null;
	public availableDate: Date = null;

    constructor(lastPublishedDate: Date = null, availableDate: Date = null) {
        this.lastPublishedDate = lastPublishedDate;
        this.availableDate = availableDate;
    }
}
